export default __webpack_public_path__ + "static/media/deposit-gpay-step4.9f74ea50.png";